/**
 * Shared constants for table components.
 * Reduces duplication across pharmaTable, productTable, chargesTable, and productPharmacyTable.
 */

// Common row spacing value used across all table components
export const ROW_SPACING = 0;

// Sentinel value for "no extended row" state
export const EXTENDED_ROW_EMPTY = -1;

// Margin for popup positioning
export const POPUP_MARGIN = 8;

// Empty/unset index sentinel
export const EMPTY_INDEX = -1;

// Fixed row heights for different table types
export const TABLE_ROW_HEIGHTS = {
  CHARGES: 70,
  PHARMA: 76,
  PRODUCT: 71,
  PRODUCT_PHARMACY: 77,
};

// Visibility limits for tables
export const TABLE_VISIBILITY = {
  MAX_VISIBLE_ITEMS: 10,
  MIN_VISIBLE_ITEMS: 5,
};
